import type { AdPlacementConfig } from 'interfaces/ads/Ad';

const BYPASS_LEADERBOARD = 'adBypass:Leaderboard';
const BYPASS_SOV_SPONSORSHIP = 'adBypass:SOVSponsorship';

export const checkForDirectSoldAd = (
  tags: string[] | undefined,
  ctype: string,
  placementName: string,
  placementConfig: AdPlacementConfig,
) => {
  const isBypassed =
    (placementName === 'Leaderboard' && tags?.includes(BYPASS_LEADERBOARD)) ||
    tags?.includes(BYPASS_SOV_SPONSORSHIP) ||
    ctype === 'homepage';

  return isBypassed
    ? {
        sizeMappings: placementConfig.sizeMappings || null,
        slotSize: placementConfig.sizeMappings?.flatMap((mapping) =>
          mapping.size.map((size) => `${size[0]}x${size[1]}`),
        ),
      }
    : { sizeMappings: null, slotSize: null };
};
